import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React from 'react'
import SummaryTable from './ReportTables/SummaryTable'
import TransactionsTable from './ReportTables/TransactionsTable'
import NoData from '../../../../elements/NoData'
import RecurringPaymentTable from './ReportTables/RecurringPaymentTable'
import RecurringDepositTable from './ReportTables/RecurringDepositTable'
import FraudAnalysisTable from './ReportTables/FraudAnalysisTable'
import TopCredits from './ReportTables/TopCredits'
import TopDebits from './ReportTables/TopDebits'
import EMITable from './ReportTables/EMITable'

const tabNames = [
    {
        id: 1,
        name: 'Summary',
        type: 'summary',
    },
    {
        id: 2,
        name: 'Transactions',
        type: 'transactions',
    },
    {
        id: 3,
        name: 'EMI',
        type: 'emi'
    },
    {
        id: 4,
        name: 'Recurring Payment',
        type: 'recu_payment'
    },
    {
        id: 5,
        name: 'Recurring Deposit',
        type: 'recu_deposit'
    },
    {
        id: 6,
        name: 'Fraud Analysis',
        type: 'fraud'
    },
    {
        id: 7,
        name: 'Top 5 Credit Transactions',
        type: 'top_credit'
    },
    {
        id: 8,
        name: 'Top 5 Debit Transactions',
        type: 'top_debit'
    },
]

export default function StatementTabs({reportData}) {
    return (
        <Box mt={10}>
            <Tabs className='tabs_container'>
                <TabList className='tabs_list' pb={4} overflowX="auto" whiteSpace="nowrap" sx={{
                        scrollbarWidth: 'thin',
                        '&::-webkit-scrollbar': {
                            height: '6px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#ccc',
                            borderRadius: '10px',
                        },
                    }}>
                    {tabNames.map((item, index) => {
                        return (
                            <Tab key={index}>{item.name}</Tab>
                        )
                    })}
                </TabList>
                <TabPanels>
                    {tabNames.map((item, index) => {
                        return (
                            <TabPanel key={index} className='tab_panel'>
                                {item.type === 'summary' &&
                                   <SummaryTable data={reportData.Summary} />
                                }
                                {item.type === 'transactions' &&
                                   <TransactionsTable data={reportData.Transactions} />
                                }
                                {item.type === 'emi' &&
                                   <EMITable data={reportData.EMI} />
                                }
                                {item.type === 'recu_payment' &&
                                   <RecurringPaymentTable data={reportData['Recurring Payment']} />
                                }
                                {item.type === 'recu_deposit' &&
                                   <RecurringDepositTable data={reportData['Recurring Deposit']} />
                                }
                                {item.type === 'fraud' &&
                                   <FraudAnalysisTable data={reportData['Fraud Analysis']} />
                                }
                                {item.type === 'top_credit' &&
                                   <TopCredits data={reportData['Top 5 Transactions'].Credit} />
                                }
                                 {item.type === 'top_debit' &&
                                   <TopDebits data={reportData['Top 5 Transactions'].Debit} />
                                }
                            </TabPanel>
                        )
                    })}
                </TabPanels>
            </Tabs>
        </Box>
    )
}
